// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iivV","col":"styles_col___JiYq","actions":"styles_actions__1aJ1Z","conflict":"styles_conflict__1_BFt"};